<template>
  <div class="rows-container">
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.reservationOrders.pending", { count: totalPendingOrders }) }}</p>
        <p style="margin: 1%;">MC({{ this.pendingOrdersCount.count_mc < 0 ? 0 : pendingOrdersCount.count_mc }}) 
          EXT({{ this.pendingOrdersCount.count_ext < 0 ? 0 : pendingOrdersCount.count_ext }}) 
          PEXT({{ this.pendingOrdersCount.count_pext < 0 ? 0 : pendingOrdersCount.count_pext }})
        </p>
      </div>
      <InfinityScroll
        status="PENDING"
        :besoin="this.besoin"
        time="RESERVATION"
        @updateTotal = "totalPendingOrders = $event"
        @decreaseCount = "totalPendingOrders--"
      />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.reservationOrders.dispatched") }}</p>
      </div>
      <InfinityScroll
        multiStatus="ACCEPTED|APPROVED"
        :besoin="this.besoin"
        time="RESERVATION"
      />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.reservationOrders.driverOnTheWay") }}</p>
      </div>
      <InfinityScroll
        multiStatus="ARRIVED|STARTED"
        :besoin="this.besoin"
        time="RESERVATION"
      />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.reservationOrders.tripStarted") }}</p>
      </div>
      <InfinityScroll
        status="PICKED_UP"
        :besoin="this.besoin"
        time="RESERVATION"
      />
    </div>
    <div class="row">
      <div class="title">
        <p>{{ $t("dispatching.reservationOrders.completed") }}</p>
      </div>
      <InfinityScroll
        multiStatus="DONE|PAID"
        :besoin="this.besoin"
        time="RESERVATION"
      />
    </div>
  </div>
</template>

<script>
import InfinityScroll from "@/components/dispatching/InfinityScroll.vue";
import socketEventsMixin from "@/mixins/socketEventsMixin.js";
import axios from "axios";

export default {
  name: "instant-orders",
  mixins: [socketEventsMixin],
  data() {
    return {
      pendingOrdersCount:[],
      besoin: 0,
      totalPendingOrders: 0,
      lastUpdate: ''
    };
  },
  components: {
    InfinityScroll,
  },
  events() {
    return {
      [this.api.SOCKET.EVENTS.RENEW_BESOIN]: this.renewBesoin,
      [this.api.SOCKET.EVENTS.EXPIRED_BESOIN]: this.expiredBesoin,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING_STATUS]: this.updateStatus,
    };
  },
  methods: {
    getPendingOrdersCount(){
      axios.get('pending_bookings_count/RESERVATION',)
      .then((res) => {
        this.pendingOrdersCount = res.data.data;
        console.log("getPendingOrdersCount");
        console.log(this.pendingOrdersCount);
      })
      .catch((err) => {
        this.errorMessage = err.response.data.message;
        console.log("err");
        console.log(this.errorMessage);
      })
    },
    renewBesoin(besoin) {
      this.besoin = besoin.booking_id;
      // this.$store.commit("SET_BESOIN", this.besoin);
    },
    expiredBesoin(besoin) {
      // this.$store.commit("DELETE_BESOIN", besoin.booking_id);
      // console.log(this.$store.state.besoins);
    },
    updateStatus(id, newStatus, oldStatus) {
      if(this.lastUpdate != `${id}:${newStatus}:${oldStatus}` && (newStatus === "ACCEPTED" || newStatus === "APPROVED"))
        this.totalPendingOrders--;
      this.lastUpdate = `${id}:${newStatus}:${oldStatus}`;
      this.getPendingOrdersCount();
    }
  },
  created(){
    this.getPendingOrdersCount();
  }
};
</script>

<style lang="scss" scoped>
.rows-container {
  width: 100%;
  height: 100%;
  float: left;
  display: flex;
  flex-direction: row;
  background-color: white;
  box-shadow: 0px 2px 6px rgba(0, 11, 138, 0.08);
  border-radius: 10px;
  margin-top: 20px;

  .row {
    flex-shrink: 0;
    flex: 1;
    min-height: 600px;
    max-height: 600px;
    min-width: 200px;
    float: left;
    padding-top: 16px;
    height: 100%;
    opacity: 0.9;

    .title {
      height: 50px;
      width: 100%;
      padding-bottom: 16px;
      float: left;
      border-bottom: 1px solid #c1c5d8;

      p {
        width: 100%;
        font-size: 14px !important;
        text-align: center;
        font-weight: 500;
        color: #4d4f5c;
        font-family: Poppins !important;
        padding: 0px;
        margin: 1%;
      }
    }

    &:not(:last-child) {
      border-right: 1px solid #c1c5d8;
    }

    &:hover {
      opacity: 1;
    }
  }
}
</style>
